import { makeContextModule } from '@cian/react-utils';

import { IAdfoxContext } from '../../types/adfox';

export const {
  Context: AdfoxContext,
  useContext: useAdfoxContext,
  withContext: withAdfoxContext,
} = makeContextModule<IAdfoxContext>({
  contextName: 'AdfoxContext',
});
